module.exports = __webpack_public_path__ + "static/media/ZhiBo1.37007cd1.png";